import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const RevenueChart = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = JSON.parse(sessionStorage.getItem("token"));

  useEffect(() => {
    getCommissionChart();
  }, [token]);

  const getCommissionChart = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}transactions/commissionChart`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = await response.json();
      console.log("Commission Chart:", result);

      if (response.ok) {
        // Map API data to recharts format
        const formattedData = result?.data?.data?.map((item) => ({
          month: item.month,
          commission: item.commission,
        }));

        setChartData(formattedData || []);
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <ChartContainer>
      <ChartWrapper>
        {loading ? (
          <Skeleton height={350} />
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={chartData}
              margin={{
                top: 20,
                right: 10,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid
                strokeDasharray="3 3"
                vertical={false}
                horizontal={false}
              />
              <XAxis
                dataKey="month"
                axisLine={true}
                tickLine={false}
                tick={{ fill: "#9CA3AF", fontSize: 10 }}
                dy={10}
              />
              <YAxis
                width={40}
                axisLine={true}
                tickLine={false}
                tick={{ fill: "#9CA3AF", fontSize: 10 }}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: "#fff",
                  border: "1px solid #E5E7EB",
                  borderRadius: "8px",
                  fontSize: "12px",
                }}
              />
              <Line
                type="monotone"
                dataKey="commission"
                stroke="#04aedb"
                strokeWidth={3}
                dot={{ fill: "#04aedb", r: 4, strokeWidth: 2, stroke: "#fff" }}
                activeDot={{
                  r: 6,
                  fill: "#04aedb",
                  strokeWidth: 2,
                  stroke: "#fff",
                }}
              />
            </LineChart>
          </ResponsiveContainer>
        )}
      </ChartWrapper>
    </ChartContainer>
  );
};

export default RevenueChart;

const ChartContainer = styled.div`
  padding: 20px;
  width: 100%;
  background: #fff;
  border-radius: 12px;
  margin-top: 0px;
`;

const ChartWrapper = styled.div`
  height: 350px;
  width: 100%;
`;
